import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles({
  faixasHonorarios__divider: {
    borderColor: '#FEFEFEAA',
    marginTop: '5px !important',
  },
});
